<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_507_29)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.4 9.59999C2.4 5.62355 5.62355 2.4 9.59999 2.4C13.5764 2.4 16.8 5.62355 16.8 9.59999C16.8 13.5764 13.5764 16.8 9.59999 16.8C5.62355 16.8 2.4 13.5764 2.4 9.59999ZM9.59999 0C4.29806 0 0 4.29806 0 9.59999C0 14.9019 4.29806 19.2 9.59999 19.2C11.8184 19.2 13.8611 18.4475 15.4868 17.1838L21.9515 23.6485C22.4201 24.1171 23.1799 24.1171 23.6485 23.6485C24.1171 23.1799 24.1171 22.4201 23.6485 21.9515L17.1838 15.4868C18.4475 13.8611 19.2 11.8184 19.2 9.59999C19.2 4.29806 14.9019 0 9.59999 0Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_507_29">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
